import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-10 md:py-24 px-4 bg-cream relative overflow-hidden" data-id="element-96">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-5 md:p-12 rounded-3xl shadow-2xl border-2 border-gold/20" data-id="element-98">
          <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-99">
            No vas a pagar{' '}
            <span className="line-through text-gray-400" data-id="element-100">$445</span>. Ni
            siquiera <span className="line-through text-gray-400" data-id="element-101">$97</span>. Ni{' '}
            <span className="line-through text-gray-400" data-id="element-102">$47</span>.
          </h2>

          <p className="text-lg text-charcoal/80 mb-8" data-id="element-103">
            Sabemos que este mensaje debe llegar a cada hogar que busca
            esperanza. Por eso, por tiempo limitado, estamos ofreciendo el
            paquete completo a un precio que no volverás a ver.
          </p>

          <div className="mb-4" data-id="element-104">
            <p className="text-sm font-bold tracking-widest text-teal uppercase mb-2" data-id="element-105">
              PRECIO DE LANZAMIENTO IRREPETIBLE
            </p>
            <div className="flex justify-center items-baseline gap-2" data-id="element-106">
              <span className="text-4xl font-bold text-teal-dark" data-id="element-107">$</span>
              <span className="text-8xl font-bold font-heading text-teal-dark tracking-tighter" data-id="element-108">
                13
              </span>
              <span className="text-4xl font-bold font-heading text-teal-dark" data-id="element-109">
                .99
              </span>
              <span className="text-xl text-charcoal/50 font-medium ml-1" data-id="element-110">
                USD
              </span>
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 p-3 rounded-lg mb-4 inline-flex items-center gap-2" data-id="element-111">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-112"></span>
            <p className="text-red-700 font-bold text-sm" data-id="element-113">
              Ahorras $431.01 USD — 97% de descuento
            </p>
          </div>

          <div className="bg-cream/50 p-4 rounded-lg mb-8 inline-block" data-id="element-114">
            <p className="text-charcoal/80 font-medium" data-id="element-115">
              Menos que un café con postre. Ebook + 4 Bonuses incluidos. Acceso
              de por vida.
            </p>
          </div>

          <div className="mb-8" data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/ph3TqvShZoWL1GB8WikDyW/hf_20260319_213435_88d14265-cbf1-4ff8-960c-f0f0c4ea3116.jpg" alt="Colección completa de El Protocolo de la Mañana y Bonus" className="w-full max-w-md mx-auto h-auto rounded-xl" data-id="element-117" />
          </div>

          <CTAButton text="¡SÍ! QUIERO MI PROTOCOLO Y MIS 4 BONUSES AHORA" className="w-full text-xl py-5" href="https://rutinasimple.com//cart/52140267077913:1" data-id="element-118" />

          <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-119">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-120"></span>
            Acceso inmediato y seguro
          </p>
        </motion.div>
      </div>
    </section>;
}